import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Cash Fast"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-cash-fast',
    templateUrl: './icon-cash-fast.component.html',
    styleUrls: ['./icon-cash-fast.component.scss'],
    standalone: false
})
export class IconCashFastComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
